import { render } from "./second.vue?vue&type=template&id=4646c72c&scoped=true"
import script from "./second.vue?vue&type=script&lang=js"
export * from "./second.vue?vue&type=script&lang=js"

import "./second.vue?vue&type=style&index=0&id=4646c72c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4646c72c"]])

export default __exports__